const CardWidgetContentInit = {
  Patient: {
    abnormalMotionEventCounts: {
      key: "abnormalMotionEventCounts",
      id: 3,
      label: "MOTION MONITORING EVENTS",
      tooltip: "Click to view all motion monitoring events",
      link: "/drilldown/abnormal",
      image: "/images/dashboard/abnormal_motion_events.png",
      counts: {
        notClassified: 0,
        actual: 0,
        severe: 0,
        total: 0,
      },
      countColorCodes: {
        severe: "#C90000",
      },
    },
    heartRateMonitoring: {
      key: "heartRateMonitoring",
      label: "HEART RATE MONITORING EVENTS",
      tooltip: "Click to view all Heart Rate Monitoring Events",
      link: "/drilldown/hrm",
      image: "/images/dashboard/hme.png",
      counts: {
        total: 0,
      },
      countColorCodes: {},
    },
    fallEvents: {
      key: "fallEvents",
      label: "FALL EVENTS",
      tooltip: "Click to view all Fall Events",
      link: "/drilldown/fallEvent",
      image: "/images/dashboard/fall_detection.png",
      counts: {
        total: 0,
      },
      countColorCodes: {},
    },
    help: {
      key: "help",
      label: "CALL FOR HELP",
      tooltip: "Click to view call for help events",
      link: "/drilldown/help",
      image: "/images/dashboard/help_icon.png",
      counts: {
        total: 0,
      },
      countColorCodes: {},
    },
    symptoms: {
      key: "symptoms",
      label: "SYMPTOMS",
      tooltip: "Click to view all Symptoms",
      link: "/drilldown/symptoms",
      image: "/images/dashboard/symptoms.png",
      counts: {
        total: 0,
      },
      countColorCodes: {},
    },
    unplannedMVDetails: {
      key: "unplannedMVDetails",
      label: "UNPLANNED MEDICAL VISITS",
      id: 9,
      subLabel: "ADMISSION/VISITS",
      tooltip: "Click to view all Unplanned medical visits",
      link: "/drilldown/unplannedMedicalVisits",
      image: "/images/dashboard/umv.png",
      counts: {
        hospital: 0,
        emergencyRoom: 0,
        doctorsOffice: 0,
        specilizedTreatmentCenter: 0,
        total: 0,
      },
      countColorCodes: {
        emergencyRoom: "#C90000",
      },
    },
    // patientMedicationCount: {
    //   key: "patientMedicationCount",
    //   label: "CURRENT MEDICATIONS",
    //   id:19,
    //   tooltip: "Click to view all Medications",
    //   link: "/drilldown/currentMedications",
    //   image: "/images/dashboard/medications.png",
    //   counts: {
    //     total: 0,
    //   },
    //   countColorCodes: {},
    // },
    medicationAdherence: {
      key: "medicationAdherence",
      label: "MEDICATION ADHERENCE",
      id: 20,
      subLabel: "EVENTS LOGGED",
      tooltip: "Click to view all Medication Adherence",
      link: "/drilldown/medicationAdherence",
      image: "/images/dashboard/care_trend.png",
      counts: {
        unknown: 0,
        taken: 0,
        skipped: 0,
        medAdherence: 0,
      },
      countColorCodes: {
        skipped: "#C90000",
      },
    },
    // patientSubscriptionDetails: {
    //   key: "patientSubscriptionDetails",
    //   label: "SUBSCRIPTION PLAN",
    //   link: "",
    //   image: "/images/dashboard/subscription.png",
    //   counts: {
    //     planName: null,
    //     status: null,
    //     startDate: null,
    //     canceledAt: null,
    //     cancellationReason: null,
    //     isOther: null,
    //     otherCancellationReason: null
    //   },
    //   countColorCodes: {},
    // },
  },
  ActivityWidgets: {
    deviceStatus: {
      key: "deviceStatus",
      title: "Device Use Status",
      tooltip: "",
      link: "",
      icon: "Device",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    battery: {
      key: "battery",
      title: "Watch Battery",
      tooltip: "",
      link: "",
      icon: "Battery",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    motionMonitoring: {
      key: "motionMonitoring",
      title: "Motion Monitoring",
      tooltip: "",
      link: "",
      icon: "Motion-Monitoring",
      settingsIcon: true,
      listLink: "/event-list/am",
      listIconTooltip: "Click to view motion monitoring",
      settingsIconTooltip: "click to view motion monitoring settings",
      settingsLink: "/settings/abnormal-motion",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    heartRateMonitoring: {
      key: "heartRateMonitoring",
      title: "Heart Rate Monitoring",
      tooltip: "",
      link: "",
      icon: "heart-rate",
      settingsIcon: true,
      listLink: "/event-list/hrm",
      listIconTooltip: "Click to view heart rate monitoring",
      settingsIconTooltip: "click to view heart rate monitoring settings",
      settingsLink: "/settings/hrm",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    callForHelp: {
      key: "callForHelp",
      title: "Call For Help",
      tooltip: "",
      link: "",
      icon: "call_alert_card_icon@2x",
      settingsIcon: true,
      settingsLink: "/settings/call-for-help",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    fallDetection: {
      key: "fallDetection",
      title: "Fall Detection",
      tooltip: "",
      link: "",
      icon: "Fall-Detection",
      settingsIcon: true,
      listLink: "/event-list/fd",
      listIconTooltip: "Click to view fall detection events",
      settingsIconTooltip: "click to view fall detection settings",
      settingsLink: "/settings/fall-detection",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    heartRate: {
      key: "heartRate",
      title: "Heart Rate",
      tooltip: "",
      link: "",
      icon: "heart-rate",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    safeLocation: {
      key: "safeLocation",
      title: "Safe Location Alert",
      tooltip: "Click to view Safe Location Alerts",
      link: "/drilldown/safeLocationAlerts",
      icon: "safe-location",
      settingsIcon: true,
      settingsIconTooltip: "click to view geo location settings",
      settingsLink: "/settings/geolocation",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    caloriesBurned: {
      key: "caloriesBurned",
      title: "Calories Burned",
      tooltip: "",
      link: "",
      icon: "Calories-Burned",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    stepsCount: {
      key: "stepsCount",
      title: "Step Count",
      tooltip: "",
      link: "",
      icon: "steps",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    sleep: {
      key: "sleep",
      title: "Sleep",
      tooltip: "",
      link: "",
      icon: "sleep",
      data: { value: null },
      countColorCodes: { value: "#3B71CA" },
    },
    currentMedication: {
      key: "currentMedication",
      title: "Current Medications",
      tooltip: "Click to view all Medications",
      link: "/drilldown/currentMedications",
      icon: "current-medications",
      data: { value: 0 },
      countColorCodes: { value: "#3B71CA" },
    },
  },
};

export default CardWidgetContentInit;
